export default {"src":"/_next/static/media/location.4072021b.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};